// extracted by mini-css-extract-plugin
export default {"main":"DesignToGoBeyondBulding_main__YwSbK","main1":"DesignToGoBeyondBulding_main1__R43hY","main2":"DesignToGoBeyondBulding_main2__IzZ-o"};